module.exports = __webpack_public_path__ + "static/HOME2-6a3ec6fe26996b6dddf2a62f9ca47a97.png";